import '../utilities/MatchMediaPolyfill'
import { getCookie } from '../utilities/getCookie'
import { setCookie } from '../utilities/setCookie'
import 'dom-slider'
const { slideToggle } = window.domSlider

const initAlertBanners = () => {
	const bannerContainer = document.getElementById('js-alerts')

	if (bannerContainer) {
		const bannerEls = bannerContainer.getElementsByClassName('js-alerts__banner ')

		// Loop through the individual notices and show them if they've not been dismissed
		for (let i = 0; i < bannerEls.length; i++) {
			const element = bannerEls[i]
			const cookieName = element.dataset.cookieName

			if (cookieName) {
				if (getCookie(cookieName) !== 'dismissed') {
					element.classList.remove('hidden')
				}
			} else {
				element.classList.remove('hidden')
			}
		}

		/*
		|--------------------------------------------------------------------------
		| When the user clicks the dismiss button, trigger our close function.
		|--------------------------------------------------------------------------
		*/
		bannerContainer.addEventListener('click', (event) => {
			let target = event.target

			// When a subpage link is clicked check if it's supposed to open a subpage nav
			if (target.classList.contains('js-alerts__dismiss')) {
				return closeAlertBanner(event)
			}
		})

		/*
		|--------------------------------------------------------------------------
		| Using the data attributes present on the dismiss button, hide the target
		| alert and set a cookie using the name and expiry.
		|--------------------------------------------------------------------------
		*/
		const closeAlertBanner = (event) => {
			if (!window.matchMedia) return

			const cookieName = event.target.dataset.cookieName
			const cookieExpiry = new Date(event.target.dataset.cookieExpiry)

			// Set a cookie
			setCookie(cookieName, 'dismissed', cookieExpiry)

			// Find a banner with the same cookie name
			const targetEl = bannerContainer.querySelector(`.js-alerts__banner[data-cookie-name="${cookieName}"]`)

			// Hide the banner
			slideToggle({
				element: targetEl,
				slideSpeed: 250,
				easing: 'ease-in-out',
			})
		}
	}
}

export default initAlertBanners
